(() => {
  'use strict';

  const normalize = (value) => {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]/g, '');
  };

  const getCurrentProductHandle = () => {
    const picker = document.querySelector('variant-picker[data-product-handle]');
    return picker?.dataset.productHandle || window.location.pathname.split('/products/')[1]?.split('/')[0];
  };

  const getSelectedOptions = () => {
    const picker = document.querySelector('variant-picker');
    if (!picker) return [];

    return [...picker.querySelectorAll('select')]
      .map((select) => select.selectedOptions?.[0]?.value || '')
      .filter(Boolean);
  };

  const getSelectedVariantId = () => {
    const picker = document.querySelector('variant-picker');
    if (!picker) return '';

    const selected = picker.querySelector('select option:checked, select option[selected]');
    return selected?.dataset.variantId || '';
  };

  const getGalleryImages = () => {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return [];

    return [...gallery.querySelectorAll('img')]
      .map((img) => ({
        img,
        src: img.currentSrc || img.src || '',
        alt: img.alt || ''
      }))
      .filter((item) => item.src);
  };

  const findMatchingImage = (selectedOptions, images) => {
    const optionTokens = selectedOptions
      .map(normalize)
      .filter((token) => token.length >= 4);

    if (!optionTokens.length) return null;

    let best = null;
    let bestScore = 0;

    for (const item of images) {
      const searchable = normalize(`${item.src} ${item.alt}`);
      const score = optionTokens.reduce((total, token) => {
        return total + (searchable.includes(token) ? 1 : 0);
      }, 0);

      if (score > bestScore) {
        bestScore = score;
        best = item;
      }
    }

    return bestScore > 0 ? best : null;
  };

  const selectGalleryImage = (matchedImage) => {
    if (!matchedImage) return false;

    const slide = matchedImage.img.closest('[data-media-id], .slideshow-slide, li');
    const gallery = document.querySelector('media-gallery');

    if (slide && gallery) {
      const allSlides = [...gallery.querySelectorAll('[data-media-id], .slideshow-slide, li')];
      const index = allSlides.indexOf(slide);
      const slideshow = gallery.querySelector('slideshow-component, slideshow-slides');

      if (index >= 0) {
        const thumbnail = gallery.querySelectorAll('button')[index];
        thumbnail?.click();

        if (slideshow && typeof slideshow.select === 'function') {
          slideshow.select(index, undefined, { animate: false });
        }
      }
    }

    // As a fallback, move the matching media container to the visual front.
    const container = matchedImage.img.closest('.product-media-container');
    if (container) {
      container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    return true;
  };

  const updateVariantUrl = () => {
    const variantId = getSelectedVariantId();
    if (!variantId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  };

  const run = () => {
    const options = getSelectedOptions();
    const images = getGalleryImages();
    const matched = findMatchingImage(options, images);

    selectGalleryImage(matched);
    updateVariantUrl();
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('variant-picker select')) {
      // Horizon uses AJAX to redraw the product gallery, so wait for it to finish.
      setTimeout(run, 500);
      setTimeout(run, 1200);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(run, 800);
  });
})();
